import {CookiesHandler} from "./CookiesHandler";

const providers = {
    CookiesHandler: new CookiesHandler(),
};

export default providers.CookiesHandler;
